import { render, staticRenderFns } from "./OrderForecastDispatchItems.vue?vue&type=template&id=f0f40642"
import script from "./OrderForecastDispatchItems.vue?vue&type=script&lang=js"
export * from "./OrderForecastDispatchItems.vue?vue&type=script&lang=js"
import style0 from "./OrderForecastDispatchItems.vue?vue&type=style&index=0&id=f0f40642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports